<template>
    <div>
        <b-card>
          <h3>Allocation Location</h3>
          <br/>
          <b-row>
            <b-col>show locations and add location here</b-col>
          </b-row>
        </b-card>
    </div>
</template>

<script>
    export default {
      data() {
      return {
        stepComplete: false,
      }
    },
    computed: {},
    components: {},
    methods:{},

    }
</script>

<style>

</style>